import styles from './HostServicesListCard.module.css'
import { HostServiceCard } from './HostServiceCard'
import { CircularProgress } from '@mui/material'
import classNames from 'classnames'
import { useMemo } from 'react'

interface HostServicesListCardProps {
    hostServices?: any[]
    hostServicesReduced?: any[]
    hostServicesFilteredByMapBounds?: any[]
    spyId?: number
    loading?: boolean
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
}

export const HostServicesListCard = (props: HostServicesListCardProps): JSX.Element => {
    const {
        hostServices,
        hostServicesReduced,
        hostServicesFilteredByMapBounds,
        loading,
        spyId,
        onStartPropertySpy,
        onStopPropertySpy
    } = props

    const textHeading = useMemo(() => {
        if (spyId === undefined || hostServicesReduced === undefined || hostServicesFilteredByMapBounds === undefined){
            return ``
        }

        return `${hostServicesFilteredByMapBounds.length} of ${hostServicesReduced.length}`
    },[
        hostServicesReduced,
        hostServicesFilteredByMapBounds,
        spyId
    ])

    if (loading === true || hostServices === undefined) {
        return (
            <div className={styles.HostServicesListCard__Loading}>
                <div>Loading</div>
                <div><CircularProgress size={80} /></div>
            </div>
        )
    }

    if (hostServices.length === 0){
        return (
            <h2>No data available</h2>
        )
    }



    const content = hostServicesFilteredByMapBounds?.map((hostService: any, index: number) => {
        return (
            <HostServiceCard
                key={hostService.id}
                hostService={hostService}
                spyId={spyId}
                index={index}
                onStartPropertySpy={onStartPropertySpy}
                onStopPropertySpy={onStopPropertySpy}
            />
        )
    })

    const HostServicesListCardClasses = classNames(styles.HostServicesListCard, {
        [styles[`HostServicesListCard--Empty`]]: hostServicesFilteredByMapBounds === undefined || hostServicesFilteredByMapBounds.length === 0
    })

    return (
        <div className={HostServicesListCardClasses}>
            <div className={styles.HostServicesListCard__Heading0Container}>
                <div className={styles.HostServicesListCard__Heading0}>
                    {textHeading}
                </div>
            </div>
            <div className={styles.HostServicesListCard__ListContainerWrapper}>
                <div className={styles.HostServicesListCard__ListContainer}>
                    {content}
                </div>  
            </div>
          
        </div>
    )
}